import React from 'react';
import styled from "styled-components";
import useMatchBackground from "../../common/hooks/sli/useMatchBackground";
import {SllMatchContext} from "./sllMatchContext";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 106px;
  border: 2px solid  #32D1DC;
  overflow: hidden;
  position: relative;
  border-radius: 6px;

  background: linear-gradient(90deg, #0056B7 0%, #0061D0 4.81%, #38A7FF 45.19%, #22FBD3 100%);


`;
const Bar = styled.div`
  width: 6px;
  height: 100%;
  background-color: #4C92FC;

`;

const HardCarryEffect = styled.div`
  @keyframes loading {
    0% {
      transform: skew(25deg) translateX(740px);
      opacity: 1;
    }
    80% {
      opacity: 1;
      transform: translateX(0);
    }
    100% {
      opacity: 0;
      transform: skew(25deg);
    }
  }

  position: absolute;
  top: 0;
  left: 0;
  width: 70px;
  height: 100%;
  background: #fff;
  opacity: 0.8;
  animation: loading 2.3s infinite linear;
  filter: blur(37px);
`;

const SllMatchItem = ({children, match, targetPuuId,data}) => {
    const {myMatch, getBackgroundString,} = useMatchBackground({match, targetPuuId,target:data});
    return (
        <SllMatchContext.Provider value={{match, myMatch,data}}>
            <Wrapper className={`match-wrapper ${getBackgroundString()}`}>
                <Bar status={data?.is_win}/>
                {children}
            </Wrapper>
        </SllMatchContext.Provider>
    );
};

export default SllMatchItem;